var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 17,
    viewBox: "0 0 52 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_14432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5332 16.7548H18.3208L20.9555 0.29834H25.1676L22.5332 16.7548Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8034 0.700617C36.9726 0.367644 35.6547 0 34.0253 0C29.8654 0 26.9361 2.24076 26.9181 5.44438C26.8836 7.808 29.0154 9.12081 30.6099 9.90891C32.2396 10.7142 32.7936 11.2399 32.7936 11.9577C32.777 13.0602 31.4767 13.5684 30.2639 13.5684C28.5821 13.5684 27.681 13.3064 26.3116 12.693L25.7569 12.4301L25.1675 16.1242C26.1554 16.5788 27.9756 16.9823 29.8654 17C34.2853 17 37.1628 14.7939 37.1969 11.38C37.2137 9.5066 36.088 8.07116 33.6611 6.8982C32.1878 6.14523 31.2855 5.63751 31.2855 4.86708C31.3028 4.1667 32.0487 3.44933 33.7118 3.44933C35.0812 3.4142 36.0873 3.7467 36.8496 4.07944L37.2305 4.25419L37.8034 0.700617Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.402 10.9249C43.7489 9.97945 45.0838 6.32047 45.0838 6.32047C45.0662 6.35561 45.43 5.35762 45.638 4.74496L45.9324 6.16295C45.9324 6.16295 46.73 10.1021 46.9033 10.9249C46.2449 10.9249 44.234 10.9249 43.402 10.9249ZM48.6016 0.29834H45.3434C44.3386 0.29834 43.5752 0.595712 43.1417 1.66374L36.8848 16.7546H41.3047C41.3047 16.7546 42.0323 14.7234 42.1887 14.286C42.6736 14.286 46.9733 14.286 47.5971 14.286C47.718 14.8638 48.0997 16.7546 48.0997 16.7546H51.9999L48.6016 0.29834Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8028 0.29834L10.6775 11.5201L10.2267 9.24417C9.46403 6.61808 7.0721 3.76489 4.40283 2.34621L8.18145 16.7373H12.6359L19.257 0.29834H14.8028Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84662 0.29834H0.0693343L0 0.630847C5.2867 1.99648 8.78798 5.28828 10.2265 9.24487L8.7532 1.68166C8.51065 0.630615 7.76524 0.33301 6.84662 0.29834Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_14432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardIcon);
export default __webpack_public_path__ + "static/media/visa-card-icon.887ad97a.svg";
export { ForwardRef as ReactComponent };